export class RejectionReason {
  id: string;
  name: string;
}
